module.exports = __webpack_public_path__ + "static/media/galerija_2014 (37).08808a7d.jpg";